import axiosInstance from './axiosInstance';

export class ApiClient {
    setToken(token: string): void {
        localStorage.setItem('authToken', token);
    }

    clearToken(): void {
        localStorage.removeItem('authToken');
    }

    getToken(): string {
        const token = localStorage.getItem('authToken');
        if(!token) {
            throw Error('Token is null')
        }
        return token
    }

    async get<T>(endpoint: string, params?: Record<string, any>): Promise<T> {
        const response = await axiosInstance.get<T>(endpoint, { params });
        return response.data;
    }

    async post<T>(endpoint: string, data?: any): Promise<T> {
        const response = await axiosInstance.post<T>(endpoint, data, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return response.data;
    }


    async postWithInitDataHeader<T>(endpoint: string, initData: string, data?: any): Promise<T> {
        const response = await axiosInstance.post<T>(endpoint, data ?? {}, {
            headers: {
                'X-Tg-Init-Data': initData,
            },
        });
        return response.data;
    }

    async put<T>(endpoint: string, data?: any): Promise<T> {
        const response = await axiosInstance.put<T>(endpoint, data);
        return response.data;
    }

    async patch<T>(endpoint: string, data?: any): Promise<T> {
        const response = await axiosInstance.patch<T>(endpoint, data);
        return response.data;
    }

    async delete<T>(endpoint: string): Promise<T> {
        const response = await axiosInstance.delete<T>(endpoint);
        return response.data;
    }
}

export const apiClient = new ApiClient();
